import React, { useState,useEffect } from "react";
import { useSelector } from "react-redux";
// MUI Icons
import {
  Delete as DeleteIcon,
  Replay as ReplayIcon,
  Palette as PaletteIcon,
  ThumbUp as ThumbUpIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import {
  Container,
  SidebarContainer,
  Item,
} from "./SidebarStyles";
import FrameSubMenu from "./FrameSubmenu";
import LogoSubmenu from "./LogoSubmenu";
// utils
import downloadImages from "../Frames/downloadImages";

const Sidebar = ({
  handleActionClick,
  photos,
  setAllPhotos,
  selectedPhotos,
  loadingPhotoIds,
  setLoadingPhotoIds,
  handleSelectAll,
  setAcceptedPhotos,
  originalImages,
  setOriginalImages,
  originalImagesLogo,
  setOriginalImagesLogo,
}) => {
  // State hooks
  const logo = useSelector((state) => state.user.logo.url);
  const [isFrameMenuVisible, setFrameMenuVisible] = useState(false);
  const [isLogoMenuVisible, setLogoMenuVisible] = useState(false);
  const [activeItemIndex, setActiveItemIndex] = useState(null);
  const toggleLogoMenu = (index) => {
    if (selectedPhotos.length === 0) {
      return;
    }
    setFrameMenuVisible(false);
    setLogoMenuVisible(!isLogoMenuVisible);
    setActiveItemIndex(index);
    if (isLogoMenuVisible) {
      setActiveItemIndex(null);
    }
  };
  useEffect(() => {
     if(selectedPhotos.length === 0)
     {
      setFrameMenuVisible(false);
      setLogoMenuVisible(false);
      setActiveItemIndex(null);
     }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPhotos]);
  const toggleFrameMenu = async (index) => {
    if (selectedPhotos.length === 0) {
      return;
    }
    setLogoMenuVisible(false);
    setFrameMenuVisible(!isFrameMenuVisible);
    setActiveItemIndex(index);
    if (isFrameMenuVisible) {
      setActiveItemIndex(null);
    }
    // Close the other submenu
  };

 
  return (
    <Container>
      <SidebarContainer>
        <Item
          isActive={activeItemIndex === 1}
          onClick={() => toggleLogoMenu(1)}
        >
          <LocalPoliceIcon style={{ color: "white" }} />
        </Item>
        <Item
          isActive={activeItemIndex === 2}
          onClick={() => toggleFrameMenu(2)}
        >
          <PaletteIcon style={{ color: "white" }} />
        </Item>
        <Item onClick={() => handleActionClick("accept")}>
          <ThumbUpIcon style={{ color: "white" }} />
        </Item>
        <Item onClick={() => handleActionClick("delete")}>
          <DeleteIcon style={{ color: "white" }} />
        </Item>
        <Item onClick={() => handleActionClick("reset")}>
          <ReplayIcon style={{ color: "white" }} />
        </Item>
        <Item onClick={() => downloadImages(selectedPhotos, photos)}>
          <DownloadIcon style={{ color: "white" }} />
        </Item>
        <FrameSubMenu
          isVisible={isFrameMenuVisible}
          photos={photos}
          selectedPhotos={selectedPhotos}
          setAllPhotos={setAllPhotos}
          setLoadingPhotoIds={setLoadingPhotoIds}
          setAcceptedPhotos={setAcceptedPhotos}
          originalImages={originalImages}
          setOriginalImages={setOriginalImages}
          originalImagesLogo={originalImagesLogo}
          setOriginalImagesLogo={setOriginalImagesLogo}
          logo={logo}
        />
        <LogoSubmenu
          isVisible={isLogoMenuVisible}
          photos={photos}
          selectedPhotos={selectedPhotos}
          setAllPhotos={setAllPhotos}
          setLoadingPhotoIds={setLoadingPhotoIds}
          setAcceptedPhotos={setAcceptedPhotos}
          originalImages={originalImages}
          setOriginalImages={setOriginalImages}
          originalImagesLogo={originalImagesLogo}
          setOriginalImagesLogo={setOriginalImagesLogo}
          logo={logo}
        />
      </SidebarContainer>
    </Container>
  );
};
export default Sidebar;
